import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ModalData } from '@app/shared/models/modal-data';
import { ButtonColors } from '@app/shared/components/button/button.constants';

@Component({
  selector: 'app-information-modal',
  templateUrl: './information-modal.component.html',
  styleUrls: ['./information-modal.component.scss']
})
export class InformationModalComponent {
  approveText: string = this.modalData.approveText;
  readonly primaryColor: ButtonColors = ButtonColors.Primary;

  constructor(
    private _dialogRef: MatDialogRef<InformationModalComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: ModalData
  ) {}

  closeModal(): void {
    this._dialogRef.close();
  }
}
